import {
  createSlice,
  isPending,
  isRejected,
  SliceSelectors,
} from "@reduxjs/toolkit";

import { checkSecureLinkThunk, getSecureLinkPageContentThunk } from "./thunks";
import { ISecureDataState, SecureDataReducers } from "./types";

const initialState: ISecureDataState = {
  pendingRequests: 0,
  loading: false,
  error: "",
  data: undefined,
  pageContent: undefined,
  processing: false,
};

export const secureDataSlice = createSlice<
  ISecureDataState,
  SecureDataReducers,
  "secureDataSlice",
  SliceSelectors<ISecureDataState>
>({
  name: "secureDataSlice",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setProcessing: (state, action) => {
      state.processing = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearData: state => {
      state.data = undefined;
      state.pageContent = undefined;
      state.error = "";
    },
  },
  extraReducers: builder => {
    builder.addCase(checkSecureLinkThunk.fulfilled, (state, { payload }) => {
      state.data = payload;
      state.processing = false;
      state.pendingRequests -= 1;
    });
    builder.addCase(
      getSecureLinkPageContentThunk.fulfilled,
      (state, { payload }) => {
        state.pageContent = payload;
        state.loading = false;
        state.pendingRequests -= 1;
      }
    );
    builder.addMatcher(
      isPending(checkSecureLinkThunk, getSecureLinkPageContentThunk),
      state => {
        state.pendingRequests += 1;
        state.error = "";
      }
    );
    builder.addMatcher(
      isRejected(checkSecureLinkThunk, getSecureLinkPageContentThunk),
      (state, action) => {
        state.pendingRequests -= 1;
        state.loading = false;
        state.processing = false;
        state.error = action.payload?.message || "Something went wrong";
      }
    );
  },
});

export const { setLoading, setProcessing, setError, clearData } =
  secureDataSlice.actions;
export default secureDataSlice.reducer;
